let additional = {
  title: 'Adicionais',
  title_s: 'Adicional',
  title_: 'Adicionais de',
  unit: 'Adicional',
  icon: 'mdi-playlist-plus',
  new: {
    title: 'Novo Adicional',
    close: 'Fechar',
    all: 'Todas',
    all_cat: 'Todas Categorias',
    category: 'Categoria',
    noChildrenText: 'Nenhuma Sub-Categoria',
    noCategoriesText: 'Sem Categorias',
    noResultsText: 'Categoria não encontrada',
    rules: {
      titleRules: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 74) || 'O Título deve ter menos que 74 caracteres'
      ],
      categoryRules: [
        v => !!v || 'Categoria é obrigatório'
      ]
    }
  },
  edit: {
    title: 'Editar Adicional'
  },
  actions: {
    new: 'Novo',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir'
  },
  status: {
    active: 'Ativo',
    inactive: 'Inativo',
    activate: 'Ativar',
    deactivate: 'Desativar'
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Adicional'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Sem Adicionais',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Adicionais por página',
    headers: {
      id: 'ID',
      code: 'Código',
      category: 'Categoria',
      title: 'Título',
      description: 'Descrição',
      price: 'Preço',
      action: 'Ações'
    }
  },
  messages: {
    error: {
      not_found: 'Adicional não encontrado'
    }
  }
}

export default additional
